import { render, staticRenderFns } from "./trilhas.vue?vue&type=template&id=efabd550"
import script from "./trilhas.vue?vue&type=script&lang=js"
export * from "./trilhas.vue?vue&type=script&lang=js"
import style0 from "./trilhas.vue?vue&type=style&index=0&id=efabd550&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports